var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarTodayFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar-today-filled_svg__clip0_130_1730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0a1 1 0 011 1v3H6V1a1 1 0 011-1zM17 0a1 1 0 011 1v3h-2V1a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4H1a1 1 0 00-1 1v18a1 1 0 001 1h22a1 1 0 001-1V5a1 1 0 00-1-1h-5v2.5a1 1 0 11-2 0V4H8v2.5a1 1 0 01-2 0V4zm11.61 8.251c.52-.515.52-1.35 0-1.865a1.344 1.344 0 00-1.886 0L10 16.047l-1.724-1.705a1.344 1.344 0 00-1.885 0c-.521.515-.521 1.35 0 1.865l2.666 2.637c.52.515 1.365.515 1.886 0l6.667-6.593z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar-today-filled_svg__clip0_130_1730"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCalendarTodayFilled;